module.exports = __webpack_public_path__ + "img/img_1.eb2c54b2.jpg";